/* Stroomkaart - translations: home page
   ============================================ */

/* eslint-disable @typescript-eslint/no-explicit-any */
export const nl = {
  /* ----- Homepage ----- */
  home: {
    title: 'Stroomkaart - Vind, reserveer en gebruik direct stroom',
    hero: {
      payoff: 'Vind, reserveer en gebruik direct stroom.',
      sub:    'De marktplaats voor passende stroomvoorzieningen.',
      cta_map: 'Open de kaart →',
      cta_how: 'Hoe werkt het?',
    },
    intro: {
      eyebrow: 'Wat is Stroomkaart?',
      title:   'Eén kaart voor alle beschikbare stroompunten in Nederland.',
      lede:    'Stroomkaart is een digitale marktplaats waar overheden, bedrijven en netbeheerders hun stroompunten beschikbaar maken voor projecten die tijdelijk stroom nodig hebben - bouw, evenementen, scheepvaart, films. Geen wachttijd op een nieuwe netaansluiting; gebruik wat er al ligt.',
    },
    tiles: {
      construction:      'Bouw & Infra',
      construction_sub:  'Tijdelijke aansluiting zonder netaanvraag',
      events:            'Evenementen',
      events_sub:        'Vaste aansluitingen op evenementenlocaties',
      ev:                'Openbare laadpalen',
      ev_sub:            'Bouwstroom uit publieke EV-infra',
      ev_charging:       'Openbare laadpalen',
      ev_charging_sub:   'Stroom uit publieke EV-infra',
      government:        'Overheidsorganisaties',
      government_sub:    'Stroompunten beschikbaar stellen',
    },
    whatis: {
      eyebrow:         'Wat is Stroomkaart',
      title:           'Eén Europese marktplaats voor tijdelijke stroombehoefte.',
      lede:            'Het elektriciteitsnet wordt steeds zwaarder belast. Voor bouwers, infrabedrijven en evenementen betekent dat langere wachttijden op een nieuwe aansluiting en stijgende kosten voor het aanleggen en behouden van eigen stroomvoorzieningen. Stroomkaart toont <strong>bestaande stroompunten die multifunctioneel kunnen worden ingezet</strong>. Reserveer een punt, plan je project en sluit aan, vaak binnen enkele dagen.',
      pill_requesters: 'Voor aanvragers',
      pill_owners:     'Voor eigenaren',
    },
    cta_strip: {
      title: 'Begin met zoeken op de kaart.',
      sub:   'Geen account nodig om te bekijken wat beschikbaar is.',
    },
    requesters_cta:     'Open de kaart',
    owners_cta:         'Meld uw aansluitingen aan',
    partners_eyebrow:   'Een greep uit de gemeenten die zijn aangesloten',
    cta_owner_btn:      'Meld uw aansluitingen aan →',
    cta_strip_title:    'Begin met zoeken op de kaart.',
    steps: {
      eyebrow: 'Zo werkt het',
      title:   'Van zoeken tot aansluiten in vier stappen.',
      lede:    'Of u nu aanvrager of eigenaar bent: het proces is bewust simpel gehouden.',
      step1_num:   'Stap 01',
      step1_title: 'Zoek op de kaart',
      step1_body:  'Filter op locatie, vermogen, periode en type aansluiting. U ziet realtime welke punten beschikbaar zijn en welke binnenkort vrijkomen.',
      step2_num:   'Stap 02',
      step2_title: 'Dien een aanvraag in',
      step2_body:  'Selecteer een punt en geef uw projectgegevens op. Aanvrager hoeft geen account te maken; bevestiging volgt per e-mail.',
      step3_num:   'Stap 03',
      step3_title: 'Aanvraag wordt beoordeeld',
      step3_body:  'Binnenkomende aanvragen worden centraal beheerd: gemeenten doen dit zelf in hun beheerportaal, voor andere eigenaren handelt het Stroomkaart-team de aanvragen af op basis van uw voorwaarden.',
      step4_num:   'Stap 04',
      step4_title: 'Aansluiten en gebruiken',
      step4_body:  'Bij goedkeuring krijgt u instructies: scan de QR-code op de kast, haal een sleutel op, of gebruik direct via de app. Verbruik wordt gemeten en achteraf gefactureerd.',
    },
    audiences: {
      eyebrow: 'Voor wie',
      title:   'Voor iedereen die stroom nodig heeft - of beschikbaar wil maken.',
      lede:    'Stroomkaart bedient twee groepen tegelijk. Aanvragers vinden snel een punt; eigenaren beheren hun aansluitingen op één plek.',
      requesters_title: 'Aanvragers',
      requesters_intro: 'Vind direct beschikbare stroompunten en dien een aanvraag in.',
      contractors:  'Aannemers',
      events_org:   'Evenementen',
      film:         'Filmorganisaties',
      owners_title: 'Eigenaren',
      owners_intro: 'Maak uw stroompunten beschikbaar en behoud volledige controle.',
      government:   'Overheidsorganisaties',
      businesses:   'Bedrijven',
    },
    types: {
      eyebrow: 'Wat voor stroompunten?',
      title:   'Verschillende soorten aansluitingen, één platform.',
      construction:    'Bouwaansluitingen',
      construction_d:  'Tijdelijke stroom voor bouw- en infraprojecten zonder lange wachttijd.',
      shore:           'Walstroom',
      shore_d:         'Schoon en stil aan de wal voor binnenvaart en haventerminals.',
      events:          'Evenementen-aansluitingen',
      events_d:        'Vaste punten op evenementenlocaties voor festivals en markten.',
      ev:              'Openbare laadpalen',
      ev_d:            'EV-infrastructuur voor licht materieel en voertuigen.',
      indirect:        'Indirecte stroompunten',
      indirect_d:      'Met een kleine aanpassing geschikt te maken voor gebruik.',
      cta_more:        'Meer info →',
    },
    cta_block: {
      title: 'Klaar om aan de slag te gaan?',
      sub:   'Open de kaart om beschikbare stroompunten te vinden, of meld er een aan om uw eigen aansluitingen toe te voegen.',
      btn_map:      'Open de kaart',
      btn_register: 'Aansluiting aanmelden',
    },
    sec1: {
      eyebrow: 'Voor aanvragers',
      title: 'Zo werkt het voor stroomzoekers.',
      sub: 'Of je nu bouwt, een evenement organiseert of op locatie filmt: in vier stappen van zoeken tot aansluiten. Geen omslachtig traject, geen losse formulieren.'
    },
    sec2: {
      eyebrow: 'Voor eigenaren',
      title: 'Zo werkt het voor eigenaren.',
      sub: 'Heeft u stroompunten die niet permanent worden gebruikt? Zet ze open via Stroomkaart. Geen aansluitkosten, geen platformkosten, wél extra inkomsten op capaciteit die u toch al heeft.'
    },
    sec3: {
      title: 'Eén kaart, veel toepassingen.',
      sub: 'Bouw en infra zijn de grootste gebruikers. Maar ook evenementen, kleine renovaties en filmsets vinden hun aansluiting via Stroomkaart.'
    },
    step1: {
      num: 'Stap 01',
      title: 'Zoek op de kaart',
      body: 'Filter op locatie, beschikbaarheid, vermogen en type aansluiting. Direct zichtbaar wat past.'
    },
    step2: {
      num: 'Stap 02',
      title: 'Doe een aanvraag',
      body: 'Vul projectinformatie en gewenst gebruik in. We controleren binnen één werkdag of het past.'
    },
    step3: {
      num: 'Stap 03',
      title: 'Ontvang instructies per e-mail',
      body: 'Je krijgt een e-mail met exact welke documenten en machtigingen je moet aanleveren, plus de deadlines.'
    },
    step4: {
      num: 'Stap 04',
      title: 'Aansluiten en starten',
      body: 'Op de afgesproken datum is je stroompunt operationeel. Verbruik wordt automatisch verrekend.'
    },
    step5: {
      num: 'Stap 01',
      title: 'Meld uw aansluitingen aan',
      body: 'Via Excel-upload of de NRG-meetdienst. Klein beginnen kan, opschalen later ook.'
    },
    step6: {
      num: 'Stap 02',
      title: 'Bepaal zelf zichtbaarheid',
      body: 'Per punt kiest u of die publiek zichtbaar is en onder welke voorwaarden. U houdt volledige controle.'
    },
    step7: {
      num: 'Stap 03',
      title: 'Beoordeel aanvragen',
      body: 'Binnenkomende aanvragen worden centraal beheerd: gemeenten doen dit zelf in hun beheerportaal, voor andere eigenaren handelt het Stroomkaart-team de aanvragen af op basis van uw voorwaarden.'
    },
    step8: {
      num: 'Stap 04',
      title: 'Verdien aan onbenutte capaciteit',
      body: 'Geen aansluitkosten, geen abonnement. U ontvangt een vergoeding per afgenomen kWh. Verbruik en verrekening lopen automatisch.'
    }
  },
};

export const en = {
  home: {
    title: 'Stroomkaart - Find, reserve and use power directly',
    hero: {
      payoff: 'Find, reserve and use power directly.',
      sub:    'The marketplace for the right power supply.',
      cta_map: 'Open the map →',
      cta_how: 'How does it work?',
    },
    intro: {
      eyebrow: 'What is Stroomkaart?',
      title:   'One map for all available power points in the Netherlands.',
      lede:    'Stroomkaart is a digital marketplace where governments, businesses and grid operators make their power points available for projects that need temporary electricity - construction, events, shipping, film. No waiting time for a new grid connection; use what is already there.',
    },
    tiles: {
      construction:      'Construction',
      construction_sub:  'Temporary grid connections at any location',
      events:            'Events',
      events_sub:        'Fixed connections at event venues',
      ev:                'Public charging points',
      ev_sub:            'Construction power from public EV infrastructure',
      ev_charging:       'Public charging stations',
      ev_charging_sub:   'Power from public EV infrastructure',
      government:        'Government',
      government_sub:    'Make power points available',
    },
    whatis: {
      eyebrow:         'What is NRGmaps',
      title:           'One European marketplace for temporary power needs.',
      lede:            'The electricity grid is under increasing strain. For builders, infrastructure firms and events, that means longer waiting times for new connections and rising costs to install and maintain their own power supplies. Stroomkaart shows <strong>existing power points that can be used for multiple purposes</strong>. Reserve a point, plan your project and connect, often within days.',
      pill_requesters: 'For applicants',
      pill_owners:     'For owners',
    },
    cta_strip: {
      title: 'Start searching on the map.',
      sub:   'No account needed to view what is available.',
    },
    requesters_cta:     'Open the map',
    owners_cta:         'Register your connections',
    partners_eyebrow:   'A selection of the municipalities that are connected',
    cta_owner_btn:      'Register your connections →',
    cta_strip_title:    'Start your search on the map.',
    steps: {
      eyebrow: 'How it works',
      title:   'From searching to connecting in four steps.',
      lede:    'Whether you are a requester or an owner: the process is intentionally kept simple.',
      step1_num:   'Step 01',
      step1_title: 'Search the map',
      step1_body:  'Filter by location, capacity, period and type of connection. You see in real time which points are available and which will become free shortly.',
      step2_num:   'Step 02',
      step2_title: 'Submit a request',
      step2_body:  'Select a point and provide your project details. Requesters do not need to create an account; confirmation follows by email.',
      step3_num:   'Step 03',
      step3_title: 'Your request is reviewed',
      step3_body:  'Incoming requests are managed centrally: municipalities handle this themselves in their admin portal; for other owners, the nrgmaps team handles requests in based on your conditions.',
      step4_num:   'Step 04',
      step4_title: 'Connect and use',
      step4_body:  'Once approved you receive instructions: scan the QR code on the cabinet, pick up a key, or use directly via the app. Consumption is metered and invoiced afterwards.',
    },
    audiences: {
      eyebrow: 'For whom',
      title:   'For everyone who needs power - or wants to make it available.',
      lede:    'Stroomkaart serves two groups at once. Requesters quickly find a point; owners manage their connections in one place.',
      requesters_title: 'Requesters',
      requesters_intro: 'Find directly available power points and submit a request.',
      contractors:  'Contractors',
      events_org:   'Event organizers',
      film:         'Film productions',
      owners_title: 'Owners',
      owners_intro: 'Make your power points available while keeping full control.',
      government:   'Government & public sector',
      businesses:   'Businesses',
    },
    types: {
      eyebrow: 'What kind of power points?',
      title:   'Different types of connections, one platform.',
      construction:    'Construction connections',
      construction_d:  'Temporary power for construction and infrastructure projects without long waiting times.',
      shore:           'Shore power',
      shore_d:         'Clean and quiet at the quayside for inland shipping and port terminals.',
      events:          'Event connections',
      events_d:        'Fixed points at event venues for festivals and markets.',
      ev:              'Public EV chargers',
      ev_d:            'EV infrastructure for light equipment and vehicles.',
      indirect:        'Indirect power points',
      indirect_d:      'Available for use with a small adjustment.',
      cta_more:        'More info →',
    },
    cta_block: {
      title: 'Ready to get started?',
      sub:   'Open the map to find available power points, or register one to add your own connections.',
      btn_map:      'Open the map',
      btn_register: 'Register a connection',
    },
    sec1: {
      eyebrow: 'For requesters',
      title: 'How it works for power seekers.',
      sub: 'Whether you are building, organising an event or filming on location: from search to connection in four steps.'
    },
    sec2: {
      eyebrow: 'For owners',
      title: 'How it works for owners.',
      sub: 'Do you have power points that are not in permanent use? Open them up via Stroomkaart. No connection costs, no platform fees, but extra income on capacity you already have.'
    },
    sec3: {
      title: 'One map, many applications.',
      sub: 'Construction and infrastructure are the largest users. But events, small renovations and filmsets also find their connection through the nrgmaps.'
    },
    step1: {
      num: 'Step 01',
      title: 'Search the map',
      body: 'Filter by location, availability, capacity and connection type. See instantly what fits.'
    },
    step2: {
      num: 'Step 02',
      title: 'Submit a request',
      body: 'Provide project information and intended use. We check within one business day whether it fits.'
    },
    step3: {
      num: 'Step 03',
      title: 'Receive instructions by email',
      body: 'You receive an email detailing exactly which documents and authorisations to provide, plus the deadlines.'
    },
    step4: {
      num: 'Step 04',
      title: 'Connect and start',
      body: 'On the agreed date your power point is operational. Consumption is settled automatically.'
    },
    step5: {
      num: 'Step 01',
      title: 'Register your connections',
      body: 'Via Excel upload or the NRG metering service. Start small, scale up later.'
    },
    step6: {
      num: 'Step 02',
      title: 'Set your own visibility',
      body: 'For each point you decide whether it is publicly visible and under what conditions. You retain full control.'
    },
    step7: {
      num: 'Step 03',
      title: 'Review requests',
      body: 'Incoming requests are managed centrally: municipalities handle this themselves in their admin portal; for other owners, the Stroomkaart team handles requests in phase 1 based on your conditions.'
    },
    step8: {
      num: 'Step 04',
      title: 'Earn from unused capacity',
      body: 'No connection costs, no subscription. You receive a fee per realised connection. Consumption and settlement run automatically.'
    }
  },
};
